<template>
    <div>
        <div>
            <SignInPCB v-if="isPC"/>
            <SignInH5B v-else/>
        </div>
    </div>
</template>
<script>

    import SignInH5B from '../components/SignInH5B';
    import SignInPCB from '../components/SignInPCB';
    import { enableAppShare } from '../../../common/js/APP/share';
    import { getCookie, setCookie } from '../../../uitl/getParam.js';
    // import { fetchQueryFNNew } from '@/service/api'
    export default {
        name: 'Index',
        components: {
            SignInPCB,
            SignInH5B
        },
        data() {
            return {
                isBView:'A',//A版      B版
            };
        },
        mounted() {
            // enableAppShare({
            //     title: '大数据高薪的必备手册',
            //     desc: 'PB级企业项目实战，全面掌握大数据高薪技能',
            //     imgUrl: 'https://s21.lgstatic.com/growth/activity/20210415/1618467842481.png'
            // });
            // this.getPageFn()
        },
        methods: {
           getPageFn() {
                const page_key = 'DATA_ENHANCEMENT';
                if (!this.isApp) {
                    let page = JSON.parse(getCookie(page_key));
                    if (!page) {
                        page = {}
                        page.pageType = Math.ceil(Math.random() * 2)
                        setCookie(page_key, JSON.stringify(page))
                    }
                    this.isBView = page.pageType == 2 ? 'B' : 'A';
                    return
                }
                let params = {
                    pageMark: page_key,//AI
                }
                fetchQueryFNNew(params).then(res => {
                    if(res.state == 1) {
                        if(res.content) { //命中页面 不返回值
                            this.isBView = 'B';
                        } else { //未命中 走a版
                            this.isBView = 'A'
                        }
                    } else {
                        this.isBView = 'A'  //默认a版  报错a版
                    }
                }).catch(error => {
                    this.isBView = 'A'  //默认a版  报错a版
                });
            },
        },
    };
</script>
